import React, { useState } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Typography, Divider, message } from 'antd';
import { PaymentElement } from '@stripe/react-stripe-js';

const { Title, Text } = Typography;

interface CheckoutFormProps {
  onPaymentSuccess: () => void;
  selectedPlan: any;
  selectedReport: any;
}

const CheckoutForm: React.FC<CheckoutFormProps> = ({
  onPaymentSuccess,
  selectedReport,
  selectedPlan,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const amount = selectedPlan?.price || 0;

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // receipt_email: userInfo.email,
        return_url: `${window.location.origin}/status`,
      },
      redirect: 'if_required',
    });

    if (error?.message) {
      setErrorMessage(error.message);
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      setErrorMessage(paymentIntent.status);
    }

    onPaymentSuccess();
    setIsProcessing(false);
    navigate('/status');
  };

  return (
    <Form
      layout='vertical'
      onSubmitCapture={handleSubmit}
      style={{ maxWidth: '400px', margin: '0 auto' }}
    >
      <Title level={4} style={{ textAlign: 'center' }}>
        Enter Your Payment Details
      </Title>
      <Divider />
      <Form.Item>
        <PaymentElement />
      </Form.Item>
      <Form.Item>
        <Button
          type='primary'
          htmlType='submit'
          disabled={isProcessing}
          style={{ width: '100%' }}
        >
          Pay {amount} £
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CheckoutForm;
